module.exports = __webpack_public_path__ + "media/images/wrong-a4de8a352ce5877f20165b0e9703679e.svg";